import Slider from '../../Elements/Slider/Slider';
import BigMenu from '../../Elements/BigMenu/BigMenu';
import BigMenuList from "../../Elements/BigMenuList/BigMenuList";
import BigMenu6Square from "../../Elements/BigMenu_6_square/BigMenu_6_square";
import React, { Component } from 'react';


export default class Middle extends Component {

	constructor(props) {
		super(props);
		// console.log("Middle:");
		// console.log();

		this.state = {
			data: props.data,
			config: props.config
		}
	}

	render() {
		// console.log("Data componentu to:"+this.state.data[0])
		// console.log("COnfig componentu to:"+this.state.config[0])
		var element = null;
		var sub_element = null;

		if (this.state.config.top_component === "slider") {

			element = <Slider data={this.state.data} config={this.state.config} icon={this.props.data.bottom_nav[0]} />;

		}
		else if (this.state.config.top_component === "big_menu") {

			element =
				<div className="big_menutopwrapper">
					<div className="big_menumask"></div>
					<div className="container">
						<BigMenu data={this.state.data} config={this.state.config} />
					</div>
				</div>;

		}
		else if (this.state.config.top_component === "big_menu_list") {
			element = (
				<div className="big_menutopwrapper">
					<div className="big_menumask" />
					<div className="container container--header-middle">
						<BigMenuList data={this.state.data} config={this.state.config} />
					</div>
				</div>
			);
		}
		else if (this.state.config.top_component === "big_menu_6") {
			element = (
				<div className="big_menutopwrapper">
					<div className="big_menumask" />
					<div className="container container--header-middle">
						<BigMenu6Square data={this.state.data} config={this.state.config} />
					</div>
				</div>
			);
		}

		return (
			<div className="header_middle">
				{element}
			</div>
		);

	}

}



// WEBPACK FOOTER //
// ./src/Components/Header/Middle/index.js